import { atom } from 'jotai'
import { atomWithStorage } from 'jotai/utils'
import { Transaction } from '.'
import { TransactionStatus } from 'sdk/omni/omni-transaction-service/types'
import { updateTransactionToast } from 'components'

export const TRANSACTION_LOCALSTORAGE_KEY = 'transactionCache'

type AddTransaction = {
  type: 'add' //INFO: new transaction
  payload: Transaction
}

type UpdateTransaction = {
  type: 'update' //INFO: update the status of the transaction
  payload: Transaction
}

type DeleteTransaction = {
  type: 'delete' //INFO: clear the list of transactions
}

type TransactionActions = AddTransaction | UpdateTransaction | DeleteTransaction

export const storedTransactionsAtom = atomWithStorage<Transaction[]>(
  TRANSACTION_LOCALSTORAGE_KEY,
  [],
)

const storedTransactions = localStorage.getItem(TRANSACTION_LOCALSTORAGE_KEY)

export const transactionsAtom = atom<Transaction[]>(
  storedTransactions !== null ? (JSON.parse(storedTransactions) as Transaction[]) : [],
)

const addTransactionAtom = atom(null, (get, set, update: Transaction) => {
  set(storedTransactionsAtom, [...get(storedTransactionsAtom), update])
  set(transactionsAtom, [...get(storedTransactionsAtom), update])
})

const updateTransactionAtom = atom(null, (get, set, update: Transaction) => {
  const { hash: actionHash, status: actionStatus } = update
  if (actionStatus !== TransactionStatus.INFLIGHT) {
    updateTransactionToast(update, true)
  }

  const updatedTransactions = get(storedTransactionsAtom)
  const updatedTransactionIndex = updatedTransactions.findIndex(
    (tx) => tx.hash === actionHash && tx.status !== actionStatus,
  )
  if (updatedTransactionIndex !== -1) {
    updatedTransactions[updatedTransactionIndex] = update
  }

  set(storedTransactionsAtom, updatedTransactions)
  set(transactionsAtom, updatedTransactions)
})

const deleteTransactionAtom = atom(null, (_, set) => {
  set(storedTransactionsAtom, [])
  set(transactionsAtom, [])
})

export const transactionsActionsAtom = atom(null, (_, set, action: TransactionActions) => {
  switch (action.type) {
    case 'add':
      return set(addTransactionAtom, action.payload)
    case 'update':
      return set(updateTransactionAtom, action.payload)
    case 'delete':
      return set(deleteTransactionAtom)
    default:
      throw new Error('unknown action')
  }
})
